import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { DepositSecurityType } from '@app/shared/types/deposi-security-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-request-choose-deposit-security',
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatRadioModule
    ],
    templateUrl: './request-choose-deposit-security.component.html',
    styleUrls: ['./request-choose-deposit-security.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestChooseDepositSecurityComponent implements OnInit, AfterViewInit {
  @ViewChild('secForm') secformView: ElementRef;

  form: FormGroup;

  securityType: DepositSecurityType;
  securityTypes = DepositSecurityType;
  

  // style
  formClass = '';

  constructor(
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef
    ) {
  }

  ngOnInit() {
    this.securityType = DepositSecurityType.WithoutSecurity;
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.formClass = this.getClass(this.secformView.nativeElement.offsetWidth);
    this.cdRef.detectChanges();
  }

  initForm(): void {
    this.form = this.fb.group({
      firstName: ['']
    });
  }

  onSecurityTypeChange(securityType: DepositSecurityType): void {
    this.securityType = securityType;
  }


  /*******************************************************************
  Style
 *******************************************************************/

  private getClass(width: number): string {
    if (width < 1000) {
      return 'form-md';
    } else if (width > 999 ) {
      return 'form-lg';
    } else {
      return '';
    }
  }


}
